export default function hideHamburgerMenu() {
  const header1 = document.querySelector('.header__menu-wrap');
  const header2 = document.querySelector('.header__menu-hamburger');

  document.body.classList.remove('header__menu--open');
  if (header1) header1.classList.remove('header__menu-wrap--open');
  if (header2) header2.classList.remove('state-active');
}
